// extracted by mini-css-extract-plugin
export var typingIndicator = "_qz-0";